import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { RankBadge } from '@/components/ui/RankBadge'
import { TeamAvatar } from '@/components/ui/TeamAvatar'

interface BubbleRowProps {
  rank: number
  schoolName: string
  conferenceName: string
  recordOverall: string
  recordConf: string
  prevRank: number | null
  logoUrl?: string | null
  slug?: string | null
  sport: string
}

function getZone(rank: number): 'safe' | 'bubble' | 'out' {
  if (rank <= 48) return 'safe'
  if (rank <= 64) return 'bubble'
  return 'out'
}

export function BubbleZoneRow({ rank, schoolName, conferenceName, recordOverall, recordConf, prevRank, logoUrl, slug, sport }: BubbleRowProps) {
  const zone = getZone(rank)

  return (
    <div className={clsx(
      'flex items-center gap-4 px-4 py-3 rounded-lg transition-colors hover:bg-pitch-800/60',
      zone === 'safe' && 'zone-safe',
      zone === 'bubble' && 'zone-bubble',
      zone === 'out' && 'zone-out',
    )}>
      <div className="w-14">
        <RankBadge rank={rank} prevRank={prevRank} size="md" />
      </div>
      <TeamAvatar name={schoolName || '?'} logoUrl={logoUrl} colorSeed={conferenceName} size="sm" />
      <div className="flex-1 min-w-0">
        {slug ? (
          <Link to={`/${sport}/teams/${slug}`} className="text-sm font-medium hover:text-accent transition-colors truncate block">
            {schoolName}
          </Link>
        ) : (
          <span className="text-sm font-medium truncate block">{schoolName}</span>
        )}
        <span className="text-xs text-slate-500">{conferenceName}</span>
      </div>
      <div className="text-sm font-mono text-slate-300 hidden sm:block" style={{ fontVariantNumeric: 'tabular-nums' }}>{recordOverall}</div>
      <div className="text-sm font-mono text-slate-500 hidden sm:block" style={{ fontVariantNumeric: 'tabular-nums' }}>{recordConf}</div>
    </div>
  )
}
